<app-go-navigation>
    <div class="space-y-4 w-full justify-center min-h-screen overflow-hidden">
        <h2>About Cevo Go</h2>

        <p>
            The revolutionary Cevo Go mobile app allows applicants for land
            mobile radio licenses from the Federal Communications Commission to
            obtain EWA-certified frequencies in hours or minutes. Not days or
            weeks. One simple, all-inclusive price. Virtually instant frequency
            coordination via your mobile device - in three easy steps! Select
            the action required, enter your technical data, then accept the
            results. An EWA Spectrum Advisor completes the process and transmits
            the finalized application to the FCC.
        </p>

        <div class="flex flex-col text-center space-y-4">
            <a href="mailto:{{ email }}">{{ email }}</a>
            <a href="{{ cevoUrl }}">Cevo.EnterpriseWireless.org</a>
            <a href="tel:{{ phoneNumber }}">{{ phoneNumber }}</a>
        </div>

        <h2 class="pt-4">About EWA</h2>

        <p>
            The Enterprise Wireless Alliance is the leading national association
            for business enterprise wireless users and the manufacturers,
            resellers and communication sales and service providers that serve
            the land mobile radio industry. An FCC-certified frequency advisory
            committee, EWA provides consulting services, frequency coordination,
            license preparation, spectrum management and associated services to
            the business/ industrial and public safety communities.
        </p>
        <img
            class="w-[25vh] mx-auto"
            src="../../../../../assets/images/EWA_Logo.jpg"
            alt="EWA Logo"
        />
    </div>
</app-go-navigation>
